<template>
  <div class="LivaRma">
    <div id="imageWrapper">
      <img :src="$store.state.rma.model.graphic" alt="" id="modelImage" />
    </div>
    <DisplayField
      :value="$store.state.rma.model.make.name"
      :label="$mlGet('liveRma-Make')"
      :placeholder="$mlGet('liveRma-MakePlaceholder')"
    />

    <DisplayField
      :value="$store.state.rma.model.name"
      :label="$mlGet('liveRma-Model')"
      :placeholder="$mlGet('liveRma-ModelPlaceholder')"
    />

    <DisplayField
      :value="$store.state.rma.serialnumber"
      :label="$mlGet('liveRma-Serialnumber')"
      :placeholder="$mlGet('liveRma-Serialnumber-Placeholder')"
    />

    <DisplayField
      v-if="$store.state.rma.reasonForReturn"
      :value="getRmaReason()"
      :label="$mlGet('liveRma-ReasonForReturn')"
    />

    <DisplayField
      v-if="rmaDateValid"
      :value="utilsDutchDate($store.state.rma.dateOfPurchase)"
      :label="$mlGet('liveRma-dateOfPurchase')"
    />

    <DisplayField
      v-if="$store.state.rma.receipt.originalname"
      :value="$store.state.rma.receipt.originalname"
      :label="$mlGet('liveRma-receipt')"
    />

    <DisplayField
      v-if="$store.state.rma.files.length > 0"
      :value="`${$store.state.rma.files.length} / 6`"
      :label="$mlGet('liveRma-files')"
    />

    <DisplayField
      v-if="$store.state.rma.transportUpsPickup"
      :value="utilsDutchDate($store.state.rma.upsPickupPreveredDate)"
      :label="$mlGet('liveRma-upsPickupPreveredDate')"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import DisplayField from "@/components/DisplayField.vue";
import { getField } from "@/multilanguage";

import { dutchDateFromString } from "@/utils/utils";

@Component({
  components: {
    DisplayField
  }
})
export default class ModelInformation extends Vue {
  get rmaDateValid() {
    return (
      this.$store.state.rma.dateOfPurchase &&
      this.$store.state.rma.dateOfPurchase.length === 10
    );
  }

  getRmaReason(): string {
    const reason = this.$store.state.rmaReasons.find(
      (reason: { id: number }) => {
        return reason.id == this.$store.state.rma.reasonForReturn;
      }
    );
    return getField(this.$store, reason.languageItemKey);
  }

  utilsDutchDate = dutchDateFromString;
}
</script>

<style scoped>
.LivaRma {
  text-align: left;
}

#imageWrapper {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid lightgray;
  height: 30ex;
  display: flex;
  justify-content: center;
  align-items: center;
}

#modelImageWrapper {
  width: 80%;
}

#modelImage {
  max-height: 28ex;
  max-width: 98%;
  margin: auto;
}

@media only screen and (max-width: 1200px) {
  #modelImage {
    max-height: 23ex;
    max-width: 98%;
    margin: auto;
  }
}

@media only screen and (max-width: 600px) {
  #modelImage {
    max-height: 19ex;
    max-width: 98%;
    margin: auto;
  }
}
</style>
